import PubSub from "underpub-js";

var HighlightCalloutShapedImage = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-HighlightCalloutShapedImage',
	};

	$.extend(true, this.options, options);

};

HighlightCalloutShapedImage.prototype.init = function() {

	var self = this;

};

export default HighlightCalloutShapedImage;
